/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */
const initialState = {
  customerlist: '',
  addcustomerresult: null,
  customereditresult: null,
  isReload: false,
  isEmailValid: '',
};

const customerReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case 'customerlist':
      return {
        ...state,
        customerlist: action.value,
      };
    case 'addcustomer':
      return {
        ...state,
        addcustomerresult: action.value,
        isReload: true,
      };
    case 'GET_SUCCESS_STATUS': {
      return {
        ...state,
        getSuccessStatus: action.value,
      };
    }
    case 'CLEAR_SUCCESS_STATUS': {
      return {
        ...state,
        getSuccessStatus: '',
      };
    }
    case 'CLEAR_EDIT_SUCCESS_STATUS': {
      return {
        ...state,
        customereditresult: '',
      };
    }
    case 'customereditdata':
      return {
        ...state,
        customereditresult: action.value,
      };
    case 'validmail':
      return {
        ...state,
        isEmailValid: action.value,
      };
    default:
      return state;
  }
};

export default customerReducer;
